import { render } from "./DailyDispatchTable.vue?vue&type=template&id=9bb55078&ts=true"
import script from "./DailyDispatchTable.vue?vue&type=script&lang=ts"
export * from "./DailyDispatchTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__